import React, { useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { forgotPass } from './login-redux';
import { Schema, Container, Content, FlexboxGrid, Panel, Form, ButtonToolbar, Button } from 'rsuite';
import { formatErrors } from '../../app/utils'
import ReCAPTCHA from "react-google-recaptcha";
import styles from './login.module.scss'


const ForgotLogin = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [formError, setFormError] = useState({});
    const [credentials, setCredentials] = useState({ email: "" });

    const { StringType } = Schema.Types;

    const model = Schema.Model({
        email: StringType().isEmail('Please insert valid email.').isRequired('Required field.')
    });

    const handleChange = useCallback(
        form => {
            setFormError({})
            setCredentials({
                email: form.email ? form.email : ""
            })
        }, [setCredentials, setFormError]
    )

    const handleFormSubmit = useCallback(
        async (recaptchaRef) => {
            const err = formatErrors(model.check(credentials));
            if (err) {
                setFormError(err)
                return;
            }
            const token = await recaptchaRef.current.executeAsync();
            dispatch(forgotPass(credentials, history, token))
        }, [dispatch, credentials, history, model, setFormError]
    )
    const recaptchaRef = React.createRef();
    const base = useSelector(state => state.base);

    return (
        <Container className={styles.login_bg}>
            <Content>
                <FlexboxGrid justify="center">
                    <FlexboxGrid.Item className={styles.login_box}>
                        <div className={styles.logo_area}>
                        <img src={`${process.env.REACT_APP_LOGO}`} alt="logo"/>
                        </div>
                        <Panel className={"bg-white"} header={<h5 className="primary-color">Forgot password</h5>} bordered shaded>
                            <Form
                                fluid
                                onChange={(e) => handleChange(e)}
                                model={model}
                                checkTrigger={"blur"}
                                formError={formError}
                                formValue={credentials}
                            >
                                <Form.Group>
                                    <Form.Control name="email" type="email" placeholder="Email" value={credentials.email} />
                                </Form.Group>
                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    size="invisible"
                                    sitekey="6LfVCKwaAAAAABVd0ATUFxK78QzLRDmxQyWcXrIE"
                                />
                                <Form.Group>
                                    <ButtonToolbar>
                                        <Button appearance="primary" type="submit" onClick={() => handleFormSubmit(recaptchaRef)} loading={base.loading}>Send email</Button>
                                        <Button appearance="link" onClick={() => history.push("/")}>Back to login</Button>
                                    </ButtonToolbar>
                                </Form.Group>
                            </Form>
                        </Panel>
                    </FlexboxGrid.Item>
                </FlexboxGrid>
            </Content>
        </Container>
    )
}

export default ForgotLogin;